import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ConfirmationDialogData {
  title?: string;
  message: string;
  cancelText?: string;
  confirmText?: string;
  showNo?: boolean;
}

@Component({
  standalone: false,
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
})
export class ConfirmationDialogComponent {
  public title = '';
  public message = '';
  public cancelText = 'No';
  public confirmText = 'Yes';
  public showNo = true;
  public useCustomLayout = false;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string | ConfirmationDialogData
  ) {
    if (typeof data === 'string') {
      this.message = data;
      return;
    }

    this.title = data.title ?? '';
    this.message = data.message;
    this.cancelText = data.cancelText ?? 'No';
    this.confirmText = data.confirmText ?? 'Yes';
    this.showNo = data.showNo ?? true;
    this.useCustomLayout = !!data.title;
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }
}
